import React from 'react';
import { useParams } from 'react-router-dom';

import Grid from '@mui/material/Grid';

import { useSectionedAssignments } from '@ts-core/hooks/assignment';

import { useStudentAuth } from 'modules/account/hooks';
import { useCourse } from 'modules/courses/hooks';
import { useAssignments } from 'modules/assignments/hooks';
import { useActivities } from 'modules/activities/hooks';

import { useAvailableExercises } from 'modules/practice/hooks';
import CreatePracticeSessionDialog, { useCreatePracticeSessionDialog } from 'modules/practice/components/CreatePracticeSessionDialog';

import TimelineAssignmentCard from './TimelineAssignmentCard';
import TimelinePracticeCard from './TimelinePracticeCard';
import TimelineActivityCard from '../TimeLineActivityCard';

export const TimelineContainer = () => {
  const { courseId } = useParams();
  const { course } = useCourse({
    courseId,
  });
  const { availableExercisesCount } = useAvailableExercises({ courseId });
  const { professor = {}, academy = {} } = course;

  const { user } = useStudentAuth();
  const { assignments: allAssignments } = useAssignments({ courseId });
  const { pendingActivities } = useActivities({ courseId });
  const { nextAssignments: assignments } = useSectionedAssignments({
    assignments: allAssignments,
  });

  const { dialogProps, onOpenCreatePracticeSessionDialog } = useCreatePracticeSessionDialog();

  if (!course?._id) return null;

  return (
    <>
      <Grid container spacing={2}>
        {availableExercisesCount > 0 && (
          <Grid item xs={12}>
            <TimelinePracticeCard
              course={course}
              user={user}
              professor={professor}
              academy={academy}
              availableExercisesCount={availableExercisesCount}
              onPractice={onOpenCreatePracticeSessionDialog}
            />
          </Grid>
        )}
        {assignments.map((assignment) => (
          <Grid key={assignment.id} item xs={12}>
            <TimelineAssignmentCard assignment={assignment} professor={professor} academy={academy} />
          </Grid>
        ))}
        {pendingActivities?.map((activity) => (
          <Grid key={activity.id} item xs={12}>
            <TimelineActivityCard activity={activity} academy={academy} />
          </Grid>
        ))}
      </Grid>
      <CreatePracticeSessionDialog {...dialogProps} />
    </>
  );
};

export default TimelineContainer;
